import { Component, OnInit } from '@angular/core';

import { DacConfig } from "../../shared/services/dac-config.service";
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  constructor(
    private dacConfig:DacConfig
  ) { }

  ngOnInit() {
  }

  get canManageAssessments() {
    return this.dacConfig.isFeatureEnabled("admin.assessments.navigation");
  }

  get shouldShowAddoHome() {
    return this.dacConfig.isFeatureEnabled("addo.dashboard.admin");
  }

  get canShop() {
    return this.dacConfig.isFeatureEnabled("admin.shop");
  }

  goToAddoHome(event:Event) {
    event.preventDefault();
    event.stopPropagation();
    
    // go to the base url
    window.location.href = "/";
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin/admin.component.ts